import { useEffect, useState } from "react";

const AIRPORT_LIST_URL = "https://pub-9b24add32f5740d88f5d4964aab0dedb.r2.dev/assets/Data/AirportList.json";

export const searchAirportList = (airports, query, excludeCode) => {
    const normalizedQuery = query.trim().toLowerCase();
    const availableAirports = airports.filter((airport) =>
        airport.display === true && airport.airportCode !== excludeCode
    );
    if (!normalizedQuery) {
        return availableAirports.slice(0, 8);
    }

    return availableAirports
        .map((airport) => {
            const airportCode = airport.airportCode.toLowerCase();
            const cityName = airport.cityName.toLowerCase();
            const airportName = airport.airportName.toLowerCase();
            const countryName = (airport.countryName || "").toLowerCase();
            const rank = airportCode.startsWith(normalizedQuery) ? 0
                : cityName.startsWith(normalizedQuery) ? 1
                    : airportName.startsWith(normalizedQuery) ? 2
                        : cityName.includes(normalizedQuery) || airportName.includes(normalizedQuery) || countryName.includes(normalizedQuery) ? 3
                            : -1;
            return { airport, rank };
        })
        .filter((result) => result.rank !== -1)
        .sort((a, b) => a.rank - b.rank || a.airport.cityName.localeCompare(b.airport.cityName))
        .slice(0, 8)
        .map((result) => result.airport);
};

const useAirportList = () => {
    const [airports, setAirports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const controller = new AbortController();

        const loadAirports = async () => {
            try {
                const response = await fetch(AIRPORT_LIST_URL, { signal: controller.signal });
                if (!response.ok) {
                    throw new Error(`Airport list request failed (${response.status})`);
                }

                const data = await response.json();
                if (!Array.isArray(data) || !data.every((airport) =>
                    airport &&
                    typeof airport.airportCode === "string" &&
                    typeof airport.cityName === "string" &&
                    typeof airport.airportName === "string"
                )) {
                    throw new Error("Airport list response has an invalid format");
                }

                setAirports(data);
                setError("");
            } catch (requestError) {
                if (requestError.name !== "AbortError") {
                    console.error("Failed to load airport list", requestError);
                    setError("Airport suggestions are temporarily unavailable. Please try again shortly.");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        loadAirports();
        return () => controller.abort();
    }, []);

    return { airports, loading, error };
};

export default useAirportList;
